import { useContext } from 'react';
import { TextsetContext } from '../containers/TextSetContextProvider/entry';

export function useTextsetContext() {
  const {
    page,
    searchTextsPerPage,
    term,
    termType,
    complexity,
    textLength,
    data,
    patientId,
    setId,
    limitModal,
    editData,
    selectedData,
    handleOuterState,
    changePage,
    changeLimitModal,
    changeData,
    changeSelectedData,
    refetchTexts,
    tags,
    scrollViewRef,
  } = useContext(TextsetContext);

  return {
    term,
    termType,
    searchTextsPerPage,
    page,
    complexity,
    limitModal,
    patientId,
    setId,
    editData,
    data,
    selectedData,
    textLength,
    changeOuterState: handleOuterState,
    changePage,
    changeLimitModal,
    changeData,
    changeSelectedData,
    refetchTexts,
    dataKeyName: 'texts',
    apiKeyName: 'textsets',
    dynamicName: 'textset',
    tags,
    scrollViewRef,
  };
}
